import { $api } from "../generated/client";

type ProductsListParams = {
	shopId: string;
};

const HOUR_MS = 60 * 60 * 1000;
const LIST_WINDOW_MS = 4 * 30 * 24 * HOUR_MS;

/**
 * Products with returns over the last 4 months.
 * `returnRequest.createdAt` is stored in milliseconds. The window is rounded
 * to the hour so the query key stays stable across renders and every consumer
 * shares the same cache entry (a `Date.now()`-based key refetched on each
 * render).
 */
export default function useAnalyticsProductsList({
	shopId,
}: ProductsListParams) {
	const toTimestamp = Math.ceil(Date.now() / HOUR_MS) * HOUR_MS;

	return $api.useQuery("get", "/shops/{shopId}/analytics/products", {
		params: {
			path: { shopId },
			query: {
				fromTimestamp: toTimestamp - LIST_WINDOW_MS,
				toTimestamp,
			},
		},
	});
}
